import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { pxToRem } from '../theme/typography';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: "85vw", sm: "400px" },
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: "10px",
    p: "24px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center"
};

export default function AlertModal({ open, setOpen, title, message, onOk }) {
    const handleClose = () => {
        setOpen(false)
        onOk && onOk()
    }
    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-modal-title"
            aria-describedby="alert-modal-description"
        >
            <Box sx={style}>
                {title && <Typography sx={{ fontSize: pxToRem(20), fontWeight: "700" }}>{title}</Typography>}
                <Typography sx={{ fontSize: pxToRem(14), fontWeight: "500", mt: "10px", color: "text.secondary" }}>
                    {message}
                </Typography>
                <Button
                    onClick={handleClose}
                    sx={{ borderRadius: "5px", height: "44px", marginTop: "20px", width: "100%" }}
                    variant="contained">
                    OK
                </Button>
            </Box>
        </Modal>
    );
}
